import {
    Component,
    OnInit,
    ViewChild,
    Output,
    EventEmitter,
    Input,
    OnDestroy,
    HostListener,
    ContentChild
} from '@angular/core';
import { CommonService } from '../../../common.service';
import { ElasticService } from 'src/app/elastic.service';
import { Router } from '@angular/router';
import { SharedService } from '../../../shared.service';
import { SearchFilterComponent } from '../search-filter/search-filter.component';
import { AdvanceSearchComponent } from '../../../common/advance-search/advance-search.component';
import Utils from '../../../utils';
import { UtilsService } from 'src/app/utils.service';
import { ApplicationService } from 'src/app/application.service';
import { GlobalSettings } from 'src/app/global.settings';
import { ProjectMappedNodeService } from 'src/app/project-mapped-node.service';
@Component({
    selector: 'app-tree-detail-search',
    templateUrl: './tree-detail-search.component.html',
    styleUrls: ['./tree-detail-search.component.scss']
})
export class TreeDetailSearchComponent implements OnInit, OnDestroy {

    // need to enable the advance search
    @Input() enableAdvanceSearch;
    // view Location
    @Input() viewLocation: any;
    // taxonomy Id to send as an input
    @Input() taxonomyId;
    // emits the search trigger event
    @Output() setSearchTriggerEvent: EventEmitter<any>;
    // search filter component
    @ViewChild('searchFilter') searchFilter: SearchFilterComponent;
    // advance search component
    @ContentChild('advanceSearch') advanceSearch: AdvanceSearchComponent;
    // search placeholder input data 
    @Input() searchPlaceholder;
    // hold the keyword to search
    searchKeyword;
    // holds the result after search
    searchResult:any = [];
    // holds value Node Type
    nodeType = Utils.NODE_TYPE.toLowerCase();
    // holds the list of dropdown keys to be displayed on the page
    dropdownKeys = ['update on', this.nodeType , 'document' ];
    // holds the entire dropdown object
    dropdownObject = {};
    // check if service has hitted , used to prevent showing up filter if the data is not loaded
    filterDataLoaded = false;
    // check if service has hitted , used to prevent showing up result
    dataLoaded = false;
    // Input filter values of the updated on ,etc
    inputForFilter = [];
    // Advance optional filter if any
    advanceOptionalFilter = {};
    // holds the search data
    saveSearchObj;
    // Search optional filter array
    searchOptionalFilters = [];
    // Additional multi select dropdown selected
    filterSelected = false;
    // Width calculation for the search panel
    maxWidth;
    // Advance Search Toggle
    advanceSearchToggle = false;
    // Margin need to appended or not
    appendMargin = false;
    // Advance search is selected or not
    isAdvanceSearch = false;
    // Accessibility text message
    textMessage = '';
    // Advance Search Data to be displayed
    advanceSearchList = [{
        name: 'item association type',
        is_selected: 0,
        type: 'key'
    }];
    // object to be used in the html to access the keys
    Object = Object;
    checkboxSelected: any;

    // Search Triggerred
    searchTrigger = false;

    // source taxonomy Id
    @Input() taxonomySourceId: any;
    // holds document type array filter
    taxonomies = [];
    //holds search text
    searchText = '';
    //holds page context based on url
    context_page: string = '';
    //holds analytics name
    analyticsName: any;
    // show Advance search toggle button
    advanceSearchFilter = false;
    // hold back button status
    showBack = true;
    loadMoreSubscription: any;
    prevMoreSubscription: any;

    resetTrigger = false;

    constructor(
        private service: CommonService,
        private elasticService: ElasticService,
        private router: Router,
        private sharedService: SharedService,
        private utilsService: UtilsService,
        private applicationService: ApplicationService,
        private mappedNodeService: ProjectMappedNodeService
    ) {
        this.setSearchTriggerEvent = new EventEmitter<any>();
        this.loadMoreSubscription = this.sharedService.loadMoreSearchResult.subscribe((event: any) => {
            if (event)
            {
                this.search(1);
            }
        });
        this.prevMoreSubscription = this.sharedService.loadMorePrevSearchResult.subscribe((event: any) => {
            if (event)
            {
                this.search(-1);
            }
        });
        // in the global search that is search in base.component.html the source taxonomy id and taxonomy id is not passed in the input
        this.sharedService.setTitleEvent.subscribe((event: any) => {
            if (event && event.type && event.type === 'taxonomy'){
                this.taxonomyId = event.document_id ;
                this.taxonomySourceId = event.source_document_id;
            }
        });
    }

    async ngOnInit() {
        this.sharedService.setSearchKeyword.subscribe((event: any) => {
            this.searchKeyword = event.keyword;
        });
        if (this.enableAdvanceSearch)
        {
            if(this.router.url.indexOf('detail') === -1) {
                this.listTaxonomies();
                this.advanceSearchList.push({
                    'name': 'project',
                    'is_selected': 0,
                    'type': 'key'
                },
                {
                    name: 'adoption status',
                    is_selected: 0,
                    type: 'key'
                });
            }

            if (this.router.url.indexOf('list') !== -1 ) {
                this.advanceSearchList.push({
                    'name': 'workflow',
                    'is_selected': 0,
                    'type': 'key'
                });
            }
            this.updateOn();
            this.getAssociationType();
            this.getProjects();
            await this.getAllNodeTypes();
        }

        switch(true){
            case (this.router.url.indexOf('taxonomy/list') !== -1) : 
            this.context_page = 'taxonomy';
            this.advanceSearchFilter = true;
            break;
    
            case (this.router.url.indexOf('taxonomy/detail') !== -1) : 
            this.context_page = 'taxonomy_detail';
            this.searchPlaceholder = 'detail';
            this.advanceSearchFilter = true;
            this.showBack = this.viewLocation !== "taxonomyViewDetails" ? true : false;
            break;
    
            case (this.router.url.indexOf('project/list') !== -1) : 
            this.context_page = 'project';
            this.advanceSearchFilter = true;
            break;
    
            case (this.router.url.indexOf('project/detail') !== -1) : 
            this.context_page = 'project_detail';
            this.advanceSearchFilter = true;
            break;
    
            case (this.router.url.indexOf('pacingguide/list') !== -1) : 
            this.context_page = 'pacingguide';
            break;
        }

        
          this.analyticsName = Utils.analyticsEvtName[this.context_page];
    }

    /**
     * Functionality to fetch all node types
     */
    async getAllNodeTypes() {
        if (this.router.url.indexOf('project/detail') !== -1) {
            this.taxonomyId = JSON.parse(localStorage.getItem('project_details')).taxonomyId;
        }
        else if(!this.taxonomyId && this.router.url.indexOf('taxonomy/detail') !== -1){
            const pos = this.router.url.split('/').indexOf('detail');
            this.taxonomyId = this.router.url.split('/')[pos + 1];
        }

        let taxonomyId = (this.router.url.indexOf('detail') !== -1 )
            ? '/' + this.taxonomyId
            : '';

        let data : any = await this.applicationService.getApplicationServiceData(
            true,
            'nodeTypeList',
            taxonomyId
        );

        data?.nodetype.forEach(element => {
            this.inputForFilter.push({
                filter_type: 'node_type_id',
                filter_value: element.source_node_type_id,
                label: element.title,
                is_selected: 0,
                filter_key: '',
                element: this.nodeType
            });
        });
        this.fillFilterRawData();
    }

    /**
     * Get Association types
     */
    async getAssociationType() {
        const data: any = await this.applicationService.getApplicationServiceData (
            true,
            'associationTypeAll',
            '/' + this.taxonomyId + '?type=all'
        );
        data?.forEach(element => {
            if (element.type_name !== 'exemplar')
            {
                this.inputForFilter.push({
                    filter_type: 'item_association_type',
                    filter_value: element.type_id,
                    label: element.display_name,
                    is_selected: 0,
                    filter_key: '',
                    element: 'item association type',
                    type: 'value',
                    case_custom_association_type: element.case_custom_association_type
                });
            }
        });
    }

    /**
     * Get Projects
     */
    async getProjects() {
        const data: any = await this.applicationService.getApplicationServiceData(
            true,
            'projectDetailsList',
            '/' + this.taxonomyId + '?project_type=1'
        );
        data?.projects.forEach(element => {
            this.inputForFilter.push({
                filter_type: 'project_id',
                filter_value: element.project_id,
                label: Utils.extractContentFromHtml(element.project_name),
                is_selected: 0,
                filter_key: '',
                element: 'project'
            });
        });
    }

    /**
     * fill the filtered raw data and create the dropdown
     */
    fillFilterRawData() {
        setTimeout(() => {
            this.createStaticDropdownObj(this.inputForFilter);
            this.filterDataLoaded = true;
        }, 1250);
    }

    /**
     * Set the static updated on filters data
     */
    updateOn() {
        this.inputForFilter.push({
            filter_type: 'update_on',
            filter_value: 'today',
            label: 'today',
            is_selected: 0,
            filter_key: '',
            element: 'update on'
        }, {
            filter_type: 'update_on',
            filter_value: 'last_seven_days',
            label: 'last seven days',
            is_selected: 0,
            filter_key: '',
            element: 'update on'
        }, {
            filter_type: 'update_on',
            filter_value: 'last_thirty_days',
            label: 'last thirty days',
            is_selected: 0,
            filter_key: '',
            element: 'update on'
        });
    }

    /**
     *  On Search enter event click
     */
    async search(loadMore) {
        this.searchTrigger = true;
        Object.keys(this.advanceOptionalFilter).forEach(element => {
            this.advanceOptionalFilter[element].forEach(item => {
                if(this.searchOptionalFilters.indexOf(item) === -1){
                    this.searchOptionalFilters.push(item);
                }
            });
        });
        this.searchOptionalFilters.length > 0
            ? this.filterSelected = true
            : this.filterSelected = false;
        const additionalAttributes = {
            taxonomyId : this.taxonomyId ,
            sourceTaxonomyId : this.taxonomySourceId
        };

        if(!this.filterSelected && ((this.searchKeyword && this.searchKeyword.trim().length < 3))){
            this.searchTrigger = false;
            return;
        }
        if (this.router.url.indexOf('project/detail') !== -1) {
            const pos = this.router.url.split('/').indexOf('detail');
            this.searchOptionalFilters.push({
                'filter_type': 'project_id',
                'filter_value': this.router.url.split('/')[pos + 1],
                'filter_key': ''
            });
        }

        this.searchResult = await this.elasticService.callElasticSearchAPI(
            this.searchOptionalFilters,
            this.searchKeyword,
            this.searchResult,
            loadMore,
            this.filterSelected,
            additionalAttributes
        );
        this.dataLoaded = true;
        this.utilsService.searchHeightCalculation();
        this.advanceSearchToggle = false;
        this.searchTrigger = false;
    }

    /**
     * Update the taxonomy ID
     */
    updatedTaxonomyId() {
        let documentId = null;
        const pos = this.router.url.split('/').indexOf('detail');
        documentId = this.router.url.split('/')[pos + 1];
        this.searchOptionalFilters.forEach((element, index) => {
            if (element.filter_type === 'document_id')
            {
                this.searchOptionalFilters.splice(index, 1);
            }
        });
        this.searchOptionalFilters.push({
            filter_type: 'document_id',
            filter_value: documentId,
            filter_key: ''
        });
    }

    /**
     * Generate dropdown object functionality Start
     *
     * @param listingData listing data in the dropdown
     */
    createStaticDropdownObj(listingData) {
        this.dropdownKeys.forEach(key => {
            this.dropdownObject[key] = [];
            listingData.forEach(obj => {
                if (obj.element === key)
                {
                    this.dropdownObject[key].push(obj);
                }
            });
        });
    }

    /**
     * Functionality to collect filter criteria functionality
     *
     * @param filterCriteria filter Criteria list
     */
    collectFilterCriteria(filterCriteria) {
        this.searchOptionalFilters = [];
        if (filterCriteria)
        {
            Object.keys(filterCriteria).forEach(element => {
                filterCriteria[element].forEach(item => {
                    this.searchOptionalFilters.push(item);
                });
            });
        }
        this.collectAdvanceFilterCriteria(null);
    }

    /**
     *  Functionality to collect the advance filter
     *
     * @param filterCriteria filter Criteria list
     */
    collectAdvanceFilterCriteria(filterCriteria) {
        if (!filterCriteria)
        {
            Object.keys(this.advanceOptionalFilter).forEach(element => {
                this.advanceOptionalFilter[element].forEach(item => {
                    let optionFind =  this.searchOptionalFilters.find(ilI =>
                        (ilI.filter_value === item.filter_value 
                            && ilI.filter_type === item.filter_type));
                    if(!optionFind){
                        this.searchOptionalFilters.push(item);
                    }
                });
            });
        }
        else {
            if (JSON.stringify(this.advanceOptionalFilter) === JSON.stringify({}))
            {
                this.advanceOptionalFilter = filterCriteria;
            } else {
                let flag = false;
                Object.keys(this.advanceOptionalFilter).forEach(key => {
                    Object.keys(filterCriteria).forEach(filterCriteriaKey => {
                        if (key === filterCriteriaKey)
                        {
                            flag = true;
                            filterCriteria[filterCriteriaKey].forEach(item => {
                                this.advanceOptionalFilter[key].push(item);
                            });
                        }
                    });
                });
                if (!flag)
                {
                    Object.keys(filterCriteria).forEach(elem => {
                        this.advanceOptionalFilter[elem] = filterCriteria[elem];
                    });
                }
            }
        }
        this.search(0);
        this.calculateWidth();
    }

    /**
     *  Calulate the dynamic width for the dropdown
     */
    calculateWidth() {
        let ulPanel = 0;
        let divSearchPanel = 0;

        if (document.getElementById('ul-panel'))
        {
            ulPanel = document.getElementById('ul-panel').offsetLeft;
        }

        if (document.getElementById('div-search-panel'))
        {
            divSearchPanel = document.getElementById('div-search-panel').offsetWidth;
        }

        const rightMargin = Math.ceil(Number(((45 / 100) * divSearchPanel)));
        this.maxWidth = window.innerWidth - rightMargin + 'px';
        document.getElementById('div-search-panel').setAttribute(
            'style',
            'max-width: ' + this.maxWidth
        );
        this.appendMargin = false;

        if (Number(ulPanel) >= Number(this.maxWidth) - rightMargin)
        {
            this.appendMargin = true;
        }
    }

    /**
     * Functionality on deleting selected items start
     *
     * @param data data to delete the selected object
     * @param evt event triggered when deleting
     *
     */
    deleteObj(data, evt) {
        Object.keys(this.advanceOptionalFilter).forEach(key => {
            if (key === data.element)
            {
                for (const keyAdvFilter in this.advanceOptionalFilter[key]) {
                    if (keyAdvFilter &&
                        JSON.stringify(this.advanceOptionalFilter[key][keyAdvFilter]) === JSON.stringify(data)
                    )
                    {
                        this.advanceOptionalFilter[key].splice(keyAdvFilter, 1);
                    }
                }

                this.searchOptionalFilters.forEach((element,index)=>{
                    if(data.filter_type === element.filter_type 
                        && data.filter_value === element.filter_value){
                        this.searchOptionalFilters.splice(index,1)
                    }
                })
            }
        });
        this.collectAdvanceFilterCriteria(null);
    }

    /**
     * To get the result count
     *
     * @returns the count value of the result
     */
    getCount() {
        return (this.searchResult.length > 0) ? this.searchResult.length : 0;
    }

    /**
     * Functionality to clear search text
     */
    clearSearchKeyword() {
        this.resetSearchFilter();
        this.searchKeyword = '';
        if (document.getElementById('searchTaxonomies'))
        {
            // only for accessibility
            this.textMessage = 'search value cleared';
            setTimeout(() => {
                this.textMessage = '';
                document.getElementById('searchTaxonomies').focus();
            }, 100);
        }
        if (!this.resetTrigger && document.getElementById('clearBtn') && this.isAdvanceSearch){
            this.search(0);
        }
    }

    /**
     * When clicked outside the searh box the event is triggerd
     *
     * @param e click outside event trigger
     * @param action action triggered when clicked outside
     */
    toggleAdvanceSearch(e: Event, action) {
        const actAccord = (((e.target as HTMLInputElement).id) === 'add-more')
            ? true
            : false;
        this.sharedService.advanceSearchOpenPanelEvent.next({
            'e':e,
            'actAccord':actAccord
        })
    }

    /**
     * show the advance search option
     *
     * @param event on the advance click icon the event is triggered
     */
    showAdvanceSearch(event) {
        event.stopPropagation();
        this.checkResetButtonDisabled();
        this.isAdvanceSearch = !this.isAdvanceSearch;
        if(this.isAdvanceSearch){
            this.onBlur(event);
        }else{
            this.onFocus(event);
            
        }
    }

    /**
     * Reset the search filter
     */
    resetSearchFilter() {
        this.searchKeyword = '';
        setTimeout(() => {
            this.emitSearchText();
        }, 300);
    }

    /**
     * Emit search Text
     */
    emitSearchText() {
        this.sharedService.searchTextEvent.next({
            text: this.searchKeyword,
            trigger: true
        });
    }

    /**
     * Event triggerd when we click ouside of text box
     *
     * @param e event triggerd when we click ouside of text box
     */
    onClickedOutside(e: Event) {
        if (((e.target as HTMLInputElement).id) === 'add-more')
        {
            this.advanceSearchToggle = true;
        }
        else if((document.getElementById('search-panel')
            && document.getElementById('search-panel').innerText === 'Select Key')
            || (document.getElementById('search-panel') !== null
            && !((document.getElementById('search-panel').innerText).trim().includes('Search for value')))
        )
        {
            this.advanceSearchToggle = false;
        }
    }
    /**
     * navigate to last visited url
     */
    resetFilters(e: Event, action) {
        this.searchTrigger = false;
        this.resetTrigger = true;
        this.advanceOptionalFilter = {};
        this.searchOptionalFilters = [];
        this.inputForFilter = [];
        const currentUrl = sessionStorage.getItem('current_url');
        this.router.navigate([currentUrl]);
        this.sharedService.treeSearchResultEvent.next({
            searchData: [],
            showSearchList: false
        });

        if(currentUrl.indexOf('taxonomy/detail') !== -1 && document.getElementById('taxonomyDataContainer')){
            document.getElementById('taxonomyDataContainer').removeAttribute('style');
        }else if(currentUrl.indexOf('taxonomy/detail') !== -1 && document.getElementById('taxonomyDataContainerTable')){
            document.getElementById('taxonomyDataContainerTable').removeAttribute('style');
        }

        this.clearSearchKeyword();
        this.isAdvanceSearch = false;
        this.checkResetButtonDisabled();
        this.unCheckSelection();
        this.advanceSearchToggle = false;
        this.sharedService.advanceSearchOpenPanelEvent.next({
            'e':e,
            'actAccord':false
        })
        
        if(currentUrl.indexOf('project/detail') !== -1 ){
            setTimeout(() => {
                this.sharedService.windowResizeEvent.next({
                    'event': e
                });
            },500)
        }
    }

    /**
     *  event when the advance filter checkbox is selected
     *
     * @param event event emitted when the advance filter checkbox is selected
     */
    onCheckboxSelectEvent(event: any){
        this.checkboxSelected = event;
        this.checkResetButtonDisabled();
    }

    /**
     * Check Reset button is disabled or enabled
     *
     * @returns whether to keep the reset button enabled or disabled
     */
    checkResetButtonDisabled(){
        if ((this.searchKeyword && this.searchKeyword.length >= 0)
            || (this.checkboxSelected && this.checkboxSelected === true)
            || (this.checkboxSelected && this.checkboxSelected > 0)
            || this.isAdvanceSearch
            || this.searchTrigger)
        {
            return false;
        }
        return true;
    }

     // destroy lifecycle event of the angular
    ngOnDestroy(){
        this.sharedService.treeSearchResultEvent.next({
            searchData: [],
            showSearchList: false
        });
        
        this.loadMoreSubscription.unsubscribe();
        this.prevMoreSubscription.unsubscribe();
        
    }

    /**
     * Function get all document list for search filter ans set in input filter
     * 
     * @return void
     */
    async listTaxonomies() {
        const data: any = await this.applicationService.getApplicationServiceData(
            false,
            'taxonomyTypeList'
        );
        this.taxonomies = data;

        if (data && data.length >= 0) {
            data.forEach(element => {
                this.inputForFilter.push({
                    'filter_type': 'document_id',
                    'filter_value': element.document_id,
                    'filter_source_value': element.source_document_id,
                    'label': Utils.extractContentFromHtml(element.title),
                    'is_selected': 0,
                    'filter_key': '',
                    'element': 'document',
                    'import_type': element.import_type
                });
            });
        }
        this.fillFilterRawData();
    }

    /**
     * Functionality to navigate to last visited screen
     * 
     * @return void
     */
    backwardNavigation() {
        const currentUrl = sessionStorage.getItem('current_url');
        this.router.navigate([currentUrl]);
        this.clearSearchKeyword();
        this.sharedService.treeSearchResultEvent.next({
            'searchData': [],
            'showSearchList': false
        });
        this.resetSearchFilter();
        this.dataLoaded = false;
        this.setSearchTriggerEvent.emit(false);
    }

    /**
     *
     * Reset all selected checkbox for fixed selection on reset action
     *
     */
    unCheckSelection() {
        this.dropdownKeys.forEach(key => {
            for (const i in this.dropdownObject[key]) {
                this.dropdownObject[key][i].is_selected = 0;
            }
        });

        this.advanceSearchList.forEach(key => {
            for (const i in this.advanceSearchList) {
                this.advanceSearchList[i].is_selected = 0;
            }
        });
    }
    @HostListener('window:click', ['$event'])
    clickout(event) {
        if(!event.target.closest('.dropdown')) {
            this.sharedService.autoCompleteEvent.next({
                id : 'test',
                val : false
            });
        }
        if(event.target.textContent.trim() !== 'search'
            && event.target.textContent.trim() !== 'Reset'
            && event.target.id !== 'searchTaxonomies' 
            && event.target.parentElement.id !== 'clearBtn')
        {
            document.getElementById('elasticSearchBar').classList.remove('active')
        }
    }

    addAdvanceSearch(){
        this.advanceSearchToggle = true;
        if ((<HTMLElement>document.querySelector('#ul-panel')).style.display !== 'block') {
            (<HTMLElement>document.querySelector('#ul-panel')).style.display = 'block';
        }
    }

    onFocus(event) {
        const element = document.getElementById('elasticSearchBar');
        element.classList.add('active');
        setTimeout(() => {
            document.getElementById('searchTaxonomies').focus();
        }, 100);
    }
    
    onBlur(event) {
        const element = document.getElementById('elasticSearchBar');
        element.classList.remove('active');
    }
}
